import React from "react";
import { UAParser } from "ua-parser-js";
const parser = new UAParser();
const osName = parser.getOS().name;
export default osName;